/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { ResponsiveContainer, SectionHeading, BackgroundContainer, SectionContainer } from "@components/elements";
import { BlobTableSectionFragment } from "@cosmos/hygraph-schema";
import { VStack } from "@panda/jsx";
import type { CleanedBlobRes } from "@cosmos/common";
import { BlobTable } from "./BlobTable.organism";

export interface BlobTableSectionProps extends BlobTableSectionFragment {
	className?: string;
	blobs?: CleanedBlobRes[];
}

export const BlobTableSection = ({ config, blobs }: BlobTableSectionProps): React.JSX.Element | null => {
	const validHeading = Boolean(config?.heading?.title || config?.heading?.desc);

	if (!validHeading && !blobs?.length) return null;

	return (
		<BackgroundContainer
			bgAnimation={config?.backgroundAnimation}
			bgImageAsset={config?.backgroundImage}
			bgFullHeight={config?.backgroundFullHeight}
			edsBackgroundColor={config?.edsBackgroundColor}
		>
			<ResponsiveContainer>
				<SectionContainer>
					<VStack alignItems="stretch" gap="eds.dimension.48" className="blob-table-section">
						{validHeading ? <SectionHeading {...config?.heading} /> : null}
						{blobs?.length ? <BlobTable blobs={blobs} /> : null}
					</VStack>
				</SectionContainer>
			</ResponsiveContainer>
		</BackgroundContainer>
	);
};
